import React from 'react';
import { BookingsTableData, BookingsApiModel, NON_EDITABLE_BOOKING_STATUSES } from './helpers';
import { CellProps } from 'react-table';
import TextInputCell from '../../../ui/Table/Cells/TextInputCell';

type BoostCodeCellProps<T extends BookingsTableData> = CellProps<T> & {
    updateBooking?: (id: number, data: BookingsApiModel) => Promise<void>;
};

const BoostCodeCell = <T extends BookingsTableData>({ updateBooking, ...props }: BoostCodeCellProps<T>) => {
    const { date_approved, platform, status, id } = props.row.original;
    const disabled =
        Boolean(date_approved) ||
        platform !== 'TIKTOK' ||
        NON_EDITABLE_BOOKING_STATUSES.includes(status) ||
        status === 'content_only';

    return (
        <TextInputCell
            {...props}
            disabled={disabled}
            onSubmit={async (value) => {
                if (typeof updateBooking === 'function' && value !== props.value) {
                    await updateBooking(id, { tiktok_ad_code: value });
                }
            }}
        />
    );
};

export default BoostCodeCell;
